import { render, staticRenderFns } from "./product3.vue?vue&type=template&id=217fb6f6&scoped=true"
import script from "./product3.vue?vue&type=script&lang=js"
export * from "./product3.vue?vue&type=script&lang=js"
import style0 from "./product3.vue?vue&type=style&index=0&id=217fb6f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217fb6f6",
  null
  
)

export default component.exports